import React from 'react';

import HookTextFormControl from '../Text/HookTextFormControl';

import ValidateService from 'services/ValidateService';

import useResources from 'hooks/useResources';

const HookEmailFormControl = (props: any) => {
    const { rules, ...rest } = props;
    const { t } = useResources();

    return (
        <HookTextFormControl
            {...rest}
            maxLength={70}
            lowerCase
            rules={{
                validate: (value: any) => {
                    return (
                        (!ValidateService.isValidEmail(value) && t('common.widget.participant.invalidEmail')) || true
                    );
                },
                ...rules,
            }}
        />
    );
};

export default HookEmailFormControl;
